<template>
  <div
    class="page-main-bottom"
    :class="{ 'is-opened': !sidebar.opened }"
  >
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["sidebar"])
  }
};
</script>
<style scoped lang="scss">
.page-main-bottom {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 0.2rem 0.4rem;
  background: #fff;
  text-align: right;
  min-width: calc(100vw - 3.2rem);
  box-shadow: 0px 8px 20px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  // &.is-opened {
  //   left: 54px;
  // }
}
</style>
